export default "__VITE_ASSET__34004a54__"